export default "__VITE_ASSET__CeS4mpDH__"